export const en = {
    titreOnglet: "Account Detail | Desjardins",
    titreOngletMobile: "Account Detail"
};
